import React from 'react';
import { Film, Loader2, Search } from 'lucide-react';

export default function AnalysisProgress() {
  return (
    <div className="mx-auto max-w-md py-12 text-center" role="status" aria-live="polite">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-purple-500/10">
        <Loader2 className="animate-spin text-purple-300" size={42} />
      </div>
      <h2 className="mt-6 text-3xl font-bold text-white">Analysing Your Reel…</h2>
      <p className="mt-3 text-gray-400">We are finding the fewest clips you need to film.</p>
      <div className="mt-8 space-y-3 text-left text-sm text-gray-300">
        <div className="flex items-center gap-3 rounded-xl border border-gray-800 bg-gray-900 p-4"><Search className="text-purple-300" size={20} /> Checking each scene</div>
        <div className="flex items-center gap-3 rounded-xl border border-gray-800 bg-gray-900 p-4"><Film className="text-purple-300" size={20} /> Reading actions, framing and timing</div>
      </div>
    </div>
  );
}
